<template>
  <div class="block">
    <el-button class="btn primary"
               :disabled="!on"
               @click="event">
      {{ text }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    text: String,
    on: Boolean,
    event: {
      type: Function,
      default: () => null,
    },
  },
};
</script>

<style scoped>

</style>
